import { render, staticRenderFns } from "./LimitsAndCreditsTable.vue?vue&type=template&id=f42680b2&scoped=true&"
import script from "./LimitsAndCreditsTable.vue?vue&type=script&lang=js&"
export * from "./LimitsAndCreditsTable.vue?vue&type=script&lang=js&"
import style0 from "./LimitsAndCreditsTable.vue?vue&type=style&index=0&id=f42680b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42680b2",
  null
  
)

export default component.exports